import React, {memo} from 'react';
import PropTypes from 'prop-types';
import Sidebar from 'cms/faqs/FaqLayout/Sidebar';

const Fission = ({sidebarLabel, moreText, categories, children}) => (
  <div className="grid">
    <Sidebar label={sidebarLabel} moreText={moreText} categories={categories} />
    <div className="grid-item-lg-7-10">
      {children}
    </div>
  </div>
);

Fission.propTypes = {
  sidebarLabel: PropTypes.string.isRequired,
  moreText: PropTypes.string,
  categories: PropTypes.array.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node
  ])
};

export default memo(Fission);
